import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { HeroAreaComponent } from './Deski/home/hero-area/hero-area.component';
import { LoginPageComponent } from './Deski/login-page/login-page.component';
import { RegisterPageComponent } from './Deski/register-page/register-page.component';
import { ErrorPageComponent } from './Deski/error-page/error-page.component';
import { SearchPropertyComponent } from './Deski/search-property/search-property.component';
import { BillDetailsComponent } from './Deski/bill-details/bill-details.component';
import { SucessComponent } from './Deski/sucess/sucess.component';
import { FaildComponent } from './Deski/faild/faild.component';
import { PropertyDetailComponent } from './Deski/property-detail/property-detail.component';
import { RegisterPropertyComponent } from './Deski/register-property/register-property.component';
import { UserPropertyListComponent } from './Deski/user-property-list/user-property-list.component';
import { UserPropertyDetailComponent } from './Deski/user-property-detail/user-property-detail.component';
import { ForgetPasswordComponent } from './Deski/forget-password/forget-password.component';
import { PaymentDetailComponent } from './Deski/payment-detail/payment-detail.component';
import { IndexComponent } from './Deski/index/index.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

const routerOptions : ExtraOptions = {
  scrollPositionRestoration:'enabled',
  anchorScrolling:'enabled'
}

const routes: Routes = [
  {path:'',component: IndexComponent, canActivate: [LoginGuard]},
  {path: 'home', component: HeroAreaComponent, canActivate: [LoginGuard]},
  {path: 'search-property', component: SearchPropertyComponent},
  {path: 'property-detail', component: PropertyDetailComponent},
  {path: 'property-detail/:id', component: PropertyDetailComponent},
  {path: 'bill-details/:id', component: BillDetailsComponent, canActivate: [AuthGuard]},
  {path:'login',component: LoginPageComponent, canActivate: [LoginGuard]},
  {path:'register',component: RegisterPageComponent},
  {path:'register-property',component: RegisterPropertyComponent, canActivate: [AuthGuard]},
  {path:'user-property-list',component: UserPropertyListComponent, canActivate: [AuthGuard]},
  {path:'user-property-detail/:id',component: UserPropertyDetailComponent, canActivate: [AuthGuard]},
  {path:'forgot-password',component: ForgetPasswordComponent},
  {path:'payment-detail/:id',component: PaymentDetailComponent, canActivate: [AuthGuard]},

  {path:'404',component: ErrorPageComponent},
  {path:'success',component: SucessComponent},
  {path:'error',component: FaildComponent},
  { path: '**', pathMatch: 'full', component: ErrorPageComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
